export default class CampaignTableData {
  constructor(id, name, startDate, endDate, remainingDays) {
    this.id = id;
    this.name = name;
    this.startDate = startDate;
    this.endDate = endDate;
    this.remainingDays = remainingDays;
  }
}